import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Typography, TypographyProps } from './Typography';
import * as styles from './ShimmerText.css';

export interface ShimmerTextProps extends TypographyProps {
  /**
   * When true, applies a shimmer animation to indicate loading state.
   * The text will pulse with a fading opacity effect.
   */
  loading?: boolean;
}

/**
 * ShimmerText extends Typography with a loading shimmer effect.
 *
 * Use this component when you need to display text that indicates
 * an in-progress or loading state with a subtle animation.
 *
 * @example
 * ```tsx
 * <ShimmerText loading={isLoading}>
 *   Querying Salesforce
 * </ShimmerText>
 * ```
 */
export const ShimmerText = forwardRef<HTMLElement, ShimmerTextProps>(
  ({ loading = false, className, ...props }, ref) => {
    return <Typography ref={ref} className={cx(className, styles.shimmerText({ loading }))} {...props} />;
  },
);

ShimmerText.displayName = 'ShimmerText';
